const PriceColorBlack = 'var(--summary-text)';
const PriceColorGray = 'var(--summary-section-title)';

const PriceFontTiny = 'var(--font-tiny)'; // 0.5rem - Quote ID
const PriceFontSmall = 'var(--font-small)'; // 0.875rem - Small labels
const PriceFontMedium = 'var(--font-medium)'; // 0.9rem - Summary box text
const PriceFontDefault = 'var(--font-default)'; // 1rem - Default text
const PriceFontTitle = 'var(--font-title)'; // 1.25rem - Section titles
const PriceFontPrice = 'var(--font-price)'; // 1.625rem - Price values

export {
  PriceColorBlack,
  PriceColorGray,
  PriceFontTiny,
  PriceFontSmall,
  PriceFontMedium,
  PriceFontDefault,
  PriceFontTitle,
  PriceFontPrice,
};
